import { AddRowActionHandler } from "./add-row";
import { CompoundActionHandler } from "./compound-handler";
import { CopyToClipboardWithArgsHandler } from "./copy-to-clipboard";
import { IncrementActionHandler } from "./increment";
import {
    CopyToClipboardActionHandler,
    OpenLinkActionHandler,
    OpenMapActionHandler,
    PhoneCallActionHandler,
    SendEmailActionHandler,
    ShowShareScreenHandler,
    TextMessageActionHandler,
} from "./legacy";
import { PushFreeScreenActionHandler } from "./link-to-screen";
import {
    AlertActionHandler,
    EnlargeImageActionHandler,
    FormScreenActionHandler,
    UploadImageActionHandler,
} from "./misc";
import { NavigateToTabHandler } from "./navigate-to-tab";
import { OpenLinkWithArgsHandler } from "./open-link";
import { OpenMapWithArgsHandler } from "./open-map";
import { OpenWebViewActionHandler } from "./open-web-view";
import { PhoneCallWithArgsHandler } from "./phone-call";
import { PopScreenHandler } from "./pop-screen";
import { PushDetailScreenHandler } from "./push-detail-screen";
import { ReshuffleHandler } from "./reshuffle";
import { ScanCodeActionHandler } from "./scan-code";
import { SendEmailWithArgsHandler } from "./send-email";
import { SetColumnsActionHandler } from "./set-columns";
import { ShowShareScreenWithArgsHandler } from "./show-share-screen";
import { ShowToastHandler } from "./show-toast";
import { SignInActionHandler } from "./sign-in";
import { TextMessageWithArgsHandler } from "./text-message";
import { ZapierWithArgsHandler } from "./zapier";
import { registerActionHandler } from ".";
import { DeliverEmailHandler } from "./deliver-email";
import { PlaySoundHandler } from "./play-sound";
import { WebhookActionHandler } from "./webhook";
import { LiveScanLinearBarcodeActionHandler } from "./live-scan-linear-barcode";
import { DeleteRowActionHandler } from "./delete-row";
import { PushUserProfileScreenActionHandler } from "./push-user-profile-screen";
import { PushEditScreenHandler } from "./push-edit-screen";

export function registerActionHandlers(): void {
    registerActionHandler(new OpenLinkActionHandler());
    registerActionHandler(new OpenLinkWithArgsHandler());
    registerActionHandler(new OpenWebViewActionHandler());
    registerActionHandler(new PhoneCallActionHandler());
    registerActionHandler(new PhoneCallWithArgsHandler());
    registerActionHandler(new TextMessageActionHandler());
    registerActionHandler(new SendEmailActionHandler());
    registerActionHandler(new AlertActionHandler());
    registerActionHandler(new CopyToClipboardActionHandler());
    registerActionHandler(new CopyToClipboardWithArgsHandler());
    registerActionHandler(new OpenMapActionHandler());
    registerActionHandler(new AddRowActionHandler());
    registerActionHandler(new SetColumnsActionHandler());
    registerActionHandler(new DeleteRowActionHandler());
    registerActionHandler(new EnlargeImageActionHandler());
    registerActionHandler(new FormScreenActionHandler());
    registerActionHandler(new PushFreeScreenActionHandler());
    registerActionHandler(new ShowShareScreenHandler());
    registerActionHandler(new UploadImageActionHandler());
    registerActionHandler(new PushDetailScreenHandler());
    registerActionHandler(new PushEditScreenHandler());
    registerActionHandler(new OpenMapWithArgsHandler());
    registerActionHandler(new ShowShareScreenWithArgsHandler());
    registerActionHandler(new SendEmailWithArgsHandler());
    registerActionHandler(new TextMessageWithArgsHandler());
    registerActionHandler(new ZapierWithArgsHandler());
    registerActionHandler(new ReshuffleHandler());
    registerActionHandler(new IncrementActionHandler());
    registerActionHandler(new SignInActionHandler());
    registerActionHandler(new PopScreenHandler());
    registerActionHandler(new NavigateToTabHandler());
    registerActionHandler(new ShowToastHandler());
    registerActionHandler(new DeliverEmailHandler());
    registerActionHandler(new ScanCodeActionHandler());
    registerActionHandler(new LiveScanLinearBarcodeActionHandler());
    registerActionHandler(new PlaySoundHandler());
    registerActionHandler(new WebhookActionHandler());
    registerActionHandler(new CompoundActionHandler());
    registerActionHandler(new PushUserProfileScreenActionHandler());
}
